import { useQuery, UseQueryResult } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { WarehouseInboundReportResponse } from './WarehouseInboundReport.types'

const fetchWarehouseInboundReport = async (
  planId: string
): Promise<WarehouseInboundReportResponse> => {
  const { data } = await request({
    url: `plan/${planId}/warehouse-inbound-report`,
    method: 'get',
  })
  return data
}

export const useWarehouseInboundReport = (
  planId: string | null
): UseQueryResult<WarehouseInboundReportResponse> => {
  return useQuery(
    ['warehouse-inbound-report', planId],
    () => fetchWarehouseInboundReport(planId!),
    {
      enabled: !!planId,
      refetchOnWindowFocus: false,
      keepPreviousData: false,
      retry: false,
    }
  )
}
